<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="formData.name"
          label="Name"
          class="mr-2"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          class="mr-2"
          v-model="formData.defaultExpenseMarkup"
          @keypress="isNumber"
          label="Default Expense Markup %"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-subheader>
        <v-btn
          icon
          @click="
            formData.serviceTypes.push({
              name: null,
              laborRate: null
            })
          "
        >
          <v-icon color="green">{{ "mdi-plus-circle" }}</v-icon>
        </v-btn>
        Service Types
      </v-subheader>
    </v-row>
    <v-container>
      <v-row v-for="(item, index) in formData.serviceTypes" :key="index">
        <v-layout>
          <v-flex mr-4>
            <v-select
              :items="sortedServiceTypes"
              label="Name"
              v-model="item.name"
            ></v-select>
          </v-flex>
          <v-flex>
            <v-text-field
              label="Labor Rate"
              v-model="item.laborRate"
              @keypress="isNumber($event)"
            ></v-text-field>
          </v-flex>
          <v-flex align-self-center xs1>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn color="red lighten-1" dark class="mb-2" v-on="on" icon
                  ><v-icon
                    small
                    @click="formData.serviceTypes.splice(index, 1)"
                  >
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" sm="6">
          <v-select
            v-model="formData.managers"
            :items="this.projectManagers"
            v-on:input="limiter"
            hide-selected
            hint="Click to add project managers"
            label="Project Management"
            multiple
            clearable
            small-chips
            deletable-chips
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
            v-model="formData.team"
            :items="this.userNames"
            hide-selected
            hint="Click to add team members"
            label="Team"
            multiple
            clearable
            disable-lookup
            small-chips
            deletable-chips
          >
          </v-select>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ProjectForm",
  props: ["userid", "data", "savingForm", "action"],
  data: () => ({
    formData: {
      serviceTypes: [{ name: null, laborRate: null }],
      name: null,
      clientId: null,
      defaultExpenseMarkup: 0,
      managers: [],
      managerIds: [],
      team: [],
      teamIds: []
    },
    userNames: [],
    userIds: [],
    projectManagers: [],
    projectManagerIds: [],
    serviceTypesByName: {},
    sortedServiceTypes: []
  }),
  computed: {
    clientStoreData() {
      return this.$store.getters.getClients;
    },
    serviceTypeStoreData() {
      return this.$store.getters.getServiceTypes;
    },
    userStoreData() {
      return this.$store.getters.getUsers;
    },
    userAdmin() {
      if (this.loggedInUser.type == "Admin") {
        return true;
      } else {
        return false;
      }
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser;
    },
    validForm() {
      var validServiceTypes = true;

      for (var item of this.formData.serviceTypes) {
        if (
          item.name === null ||
          item.name === "" ||
          item.laborRate === null ||
          item.laborRate === ""
        ) {
          validServiceTypes = false;
        }
      }
      return (
        this.formData.name !== null &&
        this.formData.name !== "" &&
        this.formData.name !== undefined &&
        validServiceTypes == true &&
        this.formData.serviceTypes.length > 0 &&
        this.formData.managers.length > 0 &&
        this.formData.team.length > 0 &&
        (this.action != "Edit" ||
          this.formData.name != this.data.name ||
          this.formData.serviceTypes != this.data.serviceTypes)
      );
    },
    companyId() {
      return this.$store.getters.getCompanyId;
    }
  },
  watch: {
    savingForm(newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.formData.managerIds = [];
        this.formData.teamIds = [];
        for (var managerId of this.projectManagerIds) {
          let user = JSON.parse(
            JSON.stringify(this.userStoreData[managerId].name)
          );
          for (var userName of this.formData.managers) {
            if (userName == user) {
              this.formData.managerIds.push(managerId);
            }
          }
        }

        for (var id of this.userIds) {
          let user = JSON.parse(JSON.stringify(this.userStoreData[id].name));
          for (var name of this.formData.team) {
            if (name == user) {
              this.formData.teamIds.push(id);
            }
          }
        }

        for (var i = 0; i < this.formData.serviceTypes.length; i++) {
          this.formData.serviceTypes[i].id = this.serviceTypesByName[
            this.formData.serviceTypes[i].name
          ];
        }

        this.$emit(
          "loading",
          this.action == "Delete"
            ? "Deleting Project"
            : this.action + "ing Project"
        );
        if (this.action == "Add") {
          this.addProject();
        } else if (this.action == "Edit") {
          this.editProject();
        } else if (this.action == "Delete") {
          this.deleteProject();
        }
      }
    },
    validForm(val) {
      if (val == true) {
        this.$emit("valid-form", true);
      } else {
        this.$emit("valid-form", false);
      }
    },
    companyId() {
      this.formData.companyId = this.companyId;
    }
  },
  _methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    limiter(e) {
      if (e.length > 2) {
        e.pop();
      }
    },
    getChangedUserData() {
      let changedData = {};
      let oldData = this.data;
      for (var key in this.formData) {
        if (oldData[key] != this.formData[key]) {
          changedData[key] = this.formData[key];
        }
      }

      return changedData;
    },
    editProject() {
      let self = this;
      self.$store
        .dispatch("editProject", {
          projectId: this.data.id,
          changedData: self.getChangedUserData()
        })
        .then(result => {
          if (result.success != true) {
            self.$emit("error", result.data.error.message);
          } else {
            self.$emit("success", "Successfully edited project!");
            self.$emit("update-table", {
              action: "edit",
              object: "project",
              item: result.data.Attributes
            });
          }
        });
    },
    refreshServiceTypeData() {
      this.serviceTypesByName = {};
      this.sortedServiceTypes = [];
      let sortedNames = [];
      for (var serviceTypeId of Object.keys(this.serviceTypeStoreData)) {
        this.serviceTypesByName[
          this.serviceTypeStoreData[serviceTypeId].name
        ] = serviceTypeId;
        sortedNames.push(this.serviceTypeStoreData[serviceTypeId].name);
      }
      this.sortedServiceTypes = sortedNames.sort();
    },
    deleteProject() {
      let self = this;
      // if (self.userAdmin == true) {
      //   self.$store.dispatch("deleteProject", self.formData.id).then(result => {
      //     if (result.success != true) {
      //       self.$emit("error", result.data.error.message);
      //     } else {
      //       self.$emit("success", "Successfully deleted project!");
      //       // self.$emit("update-table",{
      //       //   action: "delete",
      //       //   object: "project",
      //       //   item: self.formData.id
      //       // });
      //     }
      //   });
      // } else {
      self.$emit("error", "Unable to delete project.");
      //}
    },
    addProject() {
      let self = this;
      this.formData.companyId = this.companyId;
      self.$store.dispatch("addProject", this.formData).then(result => {
        if (result.success != true) {
          self.$emit("error", result.data.error.message);
        } else {
          self.$emit("success", "Successfully added project!");
          self.$emit("update-table", {
            action: "add",
            object: "project",
            item: result.data
          });
        }
      });
    }
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
  mounted() {
    if (this.data != null) {
      this.formData.clientId = this.data.clientId;
      this.refreshServiceTypeData();
      if (this.action == "Edit") {
        this.formData = JSON.parse(JSON.stringify(this.data));
        for (var i = 0; i < this.formData.serviceTypes.length; i++) {
          this.formData.serviceTypes[i].name = this.serviceTypeStoreData[
            this.formData.serviceTypes[i].id
          ].name;
        }
        let userList = [];
        for (var manId of this.formData.managers) {
          userList.push(this.userStoreData[manId].name);
        }
        this.formData.managers = userList;
        userList = [];
        for (var tId of this.formData.team) {
          userList.push(this.userStoreData[tId].name);
        }
        this.formData.team = userList;
        this.formData.teamIds = [];
        this.formData.managerIds = [];
      }
    }
    this.userNames = [];
    this.projectManagers = [];
    this.projectManagerIds = [];
    this.userIds = [];
    for (var userId of Object.keys(this.userStoreData)) {
      let user = JSON.parse(JSON.stringify(this.userStoreData[userId].name));
      this.userNames.push(user);
      this.userIds.push(userId);
      this.projectManagers.push(user);
      this.projectManagerIds.push(userId);
      // if (this.userStoreData[userId].type == "Manager") {
      //   this.projectManagers.push(user);
      //   this.projectManagerIds.push(userId);
      // }
    }
  }
};
</script>

<style>
.forceuppercase input {
  text-transform: uppercase;
}
</style>
